import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { PageLayoutComponent } from '../../../shared/layouts/page-layout/page-layout.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomAuthService } from '../../services/custom-auth.service';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { PageHeadingComponent } from '../../components/page/heading/page-heading.component';

@Component({
    selector: 'app-profile-page',
    imports: [
        PageLayoutComponent,
        AvatarComponent,
        PageHeadingComponent,
    ],
    templateUrl: './profile-page.component.html',
    styleUrl: './profile-page.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ProfilePageComponent {
    user = toSignal(this.authService.user$);

    userProfile = computed(() => {
        const user = this.user();
        if (!user) return null;

        const firstName = user.given_name;
        const lastName = user.family_name;
        const name = user.name ?? user.email;

        // If there is a name but no first and last name, split the name by space
        if (name && !firstName && !lastName) {
            const parts = name.split(' ');
            return {
                firstName: parts[0],
                lastName: parts[1] ?? '',
                email: user.email,
                picture: user.picture,
            };
        }

        return {
            firstName: firstName ?? '',
            lastName: lastName ?? '',
            email: user.email,
            picture: user.picture,
        };
    });

    constructor(
        private readonly authService: CustomAuthService,
    ) {
    }

    logout() {
        this.authService.logout();
    }
}
